module.exports = __webpack_public_path__ + "static/media/vacationMenu.82db3468.svg";